import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { mtsLoginLogo } from '../config/app.config';
import { routes } from '../config/routes.config';
import { Icons } from '../handlers/icon.handler';
import { HttpService } from '../main/http-service';

@Component({
   selector: 'app-maintenance',
   templateUrl: './maintenance.component.html',
   styleUrls: ['./maintenance.component.css'],
})
export class MaintenanceComponent implements OnDestroy {
   icons = Icons;

   mtsLogo = mtsLoginLogo;

   service: HttpService;

   interval: NodeJS.Timeout;

   constructor(public route: ActivatedRoute, public http: HttpClient, public router: Router) {
      this.service = new HttpService(this.http, routes.session);
      this.interval = setInterval(() => {
         AppComponent.session = undefined;
         this.service.get({}, (res) => {
            if(res.status === 403 || res.status === 200) {
               AppComponent.logoutEvent.next();
               clearInterval(this.interval);
            } 
         });
      }, 60_000);
   }

   ngOnDestroy(): void {
      AppComponent.session = undefined;
      AppComponent.logoutEvent.next();
      clearInterval(this.interval);
   }
   
}
